import { render, staticRenderFns } from "./NotificationBadge.vue?vue&type=template&id=729309cc&scoped=true&"
import script from "./NotificationBadge.vue?vue&type=script&lang=js&"
export * from "./NotificationBadge.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBadge.vue?vue&type=style&index=0&id=729309cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729309cc",
  null
  
)

export default component.exports